// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavComponent_navItem__MqBti","navItemDate":"NavComponent_navItemDate__3q9xP"};